module.exports = __webpack_public_path__ + "static/media/account.351c1c27.svg";